'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationBudgetTargetController = function ConfigurationBudgetTargetController(dataRetrieverService, $scope, configurationBudgetTargetService, configurationLoaderService, dataRetrieverConstantsService, configurationService, $q) {
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_BUDGET_TARGET_MODE).setCustomSearchCriteriaRules([]);
  function getModifiedRows(rows) {
    return _.chain(rows).filter('_old').map(function (item) {
      var newItem = _.clone(item);
      newItem.origin = item.marketOrigin;
      newItem.destination = item.marketDestination;
      return newItem;
    }).value();
  }
  function validate(rows) {
    var promise = $q.defer();
    var modifiedRows = getModifiedRows(rows);
    if (modifiedRows.every(configurationService.isNonCodeShareMarket)) {
      promise.resolve(rows);
    } else {
      promise.reject('You can\'t save Code Share Market');
    }
    return promise.promise;
  }
  function validationFailure(message) {
    return message && toastr.error(message);
  }
  $scope.saveChanges = function (event, rows) {
    validate(rows).then(configurationBudgetTargetService.saveConfigurationBudgetTarget).then(function () {
      $scope.$broadcast('configuration-budget-target:saveSuccess');
    })["catch"](validationFailure);
  };
  $scope.loadedSuccessful = function (event, data) {
    configurationBudgetTargetService.setId(data.domain.id);
  };
  $scope.removeBudgetTarget = function (event, rowsToRemove) {
    configurationBudgetTargetService.removeTarget(rowsToRemove).then(function () {
      $scope.$broadcast('grid:dataChanged');
    });
  };
};
ConfigurationBudgetTargetController.$inject = ['DataRetrieverService', '$scope', 'ConfigurationBudgetTargetService', 'ConfigurationLoaderService', 'DataRetrieverConstantsService', 'ConfigurationService', '$q'];
module.exports = ConfigurationBudgetTargetController;